import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useDashboard } from '../../contexts/DashboardContext';

interface DashboardToolbarProps {
  onOpenCatalog: () => void;
}

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Bom dia';
  if (hour < 18) return 'Boa tarde';
  return 'Boa noite';
};

const DashboardToolbar: React.FC<DashboardToolbarProps> = ({ onOpenCatalog }) => {
  const { user } = useAuth();
  const { editMode, setEditMode, saveLayout, resetLayout } = useDashboard();

  const handleSave = async () => {
    try {
      await saveLayout();
      setEditMode(false);
    } catch {
      // Error handled in context
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 'var(--space-5)',
      flexWrap: 'wrap',
      gap: 'var(--space-3)',
    }}>
      {/* Greeting */}
      <div>
        <h1 style={{
          fontSize: 'var(--text-2xl)',
          fontWeight: 'var(--font-weight-bold)',
          color: 'var(--text-primary)',
          margin: 0,
        }}>
          {getGreeting()}, {user?.first_name || 'Usuario'}
        </h1>
        <p style={{
          fontSize: 'var(--text-sm)',
          color: 'var(--text-tertiary)',
          margin: 0,
          marginTop: '2px',
        }}>
          Aqui esta o resumo do seu CRM
        </p>
      </div>

      {/* Action buttons */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
        {editMode ? (
          <>
            <button onClick={onOpenCatalog} style={btnPrimary}>
              + Adicionar Widget
            </button>
            <button onClick={resetLayout} style={btnGhost}>
              Resetar
            </button>
            <button onClick={handleSave} style={btnSuccess}>
              Salvar
            </button>
            <button onClick={() => setEditMode(false)} style={btnGhost}>
              Cancelar
            </button>
          </>
        ) : (
          <button onClick={() => setEditMode(true)} style={btnOutline}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
            Personalizar
          </button>
        )}
      </div>
    </div>
  );
};

const btnBase: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '8px 16px',
  borderRadius: 'var(--radius-lg)',
  fontSize: 'var(--text-sm)',
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'all 0.15s',
  border: 'none',
  lineHeight: 1.2,
};

const btnPrimary: React.CSSProperties = {
  ...btnBase,
  background: 'var(--bg-gradient)',
  color: 'white',
};

const btnSuccess: React.CSSProperties = {
  ...btnBase,
  background: 'linear-gradient(135deg, #10b981, #059669)',
  color: 'white',
};

const btnOutline: React.CSSProperties = {
  ...btnBase,
  background: 'transparent',
  border: '1px solid var(--glass-border)',
  color: 'var(--text-secondary)',
};

const btnGhost: React.CSSProperties = {
  ...btnBase,
  background: 'transparent',
  color: 'var(--text-tertiary)',
};

export default DashboardToolbar;
